import { translateCity, translateCountry } from 'utils/TranslationHelper';

const locationTextPretty = (
  city: string,
  country: string,
  place = '',
): string => {
  if (place) {
    return place;
  }

  if (!!city && !!country) {
    return `${translateCity(city, true)}, ${translateCountry(country, true)}`;
  }

  if (!!city && !country) {
    return translateCity(city, true);
  }

  if (!!country && !city) {
    return translateCountry(country, true);
  }

  return null;
};

export const locationTextPrettyNonTranslated = (
  city: string,
  country: string,
): string => {
  if (!!city && !!country) {
    return `${city}, ${country}`;
  }

  if (!!city && !country) {
    return city;
  }

  if (!!country && !city) {
    return country;
  }

  return null;
};

export default locationTextPretty;
